<script>
export default {
    page() {
        const title = 'Search'
        const description = 'Search FRISKY for mixes, shows, artists, and genres.'
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed, watch } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router/composables'
import { useStore } from '@composables/use-store'
import Layout from '@layouts/main-layout'
import SearchBar from '@components/search/search-bar'
import recentSearchService from '@services/search/recent-search-service'

const RECENT_SEARCH_OPTIONS = ['artist', 'genre', 'mix', 'show']

const route = useRoute()
const router = useRouter()
const store = useStore()

const searchKeyword = computed(() => store.state.search.keyword)

onBeforeRouteLeave((to, from, next) => {
    const itemId = to.params.id || to.params.slug
    if (RECENT_SEARCH_OPTIONS.includes(to.name) && itemId && !to.query.back) {
        recentSearchService.addToRecent({
            id: `${to.name}-${itemId}`,
            type: to.name,
            itemId,
        })
    }
    next()
})

watch(searchKeyword, keyword => {
    if (keyword) {
        router.push({
            name: route.name.includes('search/results') ? route.name : 'search/results/top',
            params: { keyword: keyword.replace(/ /g, '_') },
        })
    } else {
        router.push({ name: 'search' })
    }
})
</script>

<template>
    <Layout :hide-mobile-menu-bar="true">
        <!-- Mobile-only search bar positioned as header (hidden on desktop) -->
        <div class="mobile-search-bar">
            <SearchBar />
        </div>
        <BaseContent class="search-area">
            <transition
                name="fade"
                mode="out-in"
            >
                <router-view />
            </transition>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.search-area {
    min-height: calc(100vh - #{$size-music-player} - #{$size-search-bar-height});

    @include desktop {
        min-height: calc(100vh - #{$size-music-player});
    }
}

.mobile-search-bar {
    position: sticky;
    top: 0;
    z-index: $layer-dropdown-z-index;

    @include desktop {
        display: none;
    }
}
</style>
